import { DeleteConfirmDialog } from "@/components/ui/delete-confirm-dialog";
import { Theme } from "@/types/theme.types";

interface BulkDeleteConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  themes: Theme[];
  onConfirm: () => Promise<void>;
  isDeleting: boolean;
}

export function BulkDeleteConfirmDialog({
  open,
  onOpenChange,
  themes,
  onConfirm,
  isDeleting,
}: BulkDeleteConfirmDialogProps): JSX.Element {
  return (
    <DeleteConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      items={themes}
      onConfirm={onConfirm}
      isDeleting={isDeleting}
      entityName="theme"
      getItemLabel={(theme) => theme.name}
      description="You are about to permanently delete the following custom themes:"
    />
  );
}
